import React from 'react'
import { Card, Row, Col } from 'react-bootstrap';

import SingleLeyendLabel from '../../../../support/SingleLeyendLabel';

const labels = [
  {
    label: 'NumRegIdTrib',
    index: 'NumRegIdTrib'
  },
  {
    label: 'Residencia Fiscal',
    index: 'ResidenciaFiscal',
  }
];

const ComplementoComercioExteriorPropietarioResumen = ({ data = {} }) => {

  const renderLeyends = (item) => {
    return (
      <SingleLeyendLabel
        key={ item.index }
        label={ item.label }
        index={ item.index }
        data={ data }
        render={ item.render }
      />
    )
  }

  return (
    <Card className="mb-2">
      <Card.Body>

      <Row>
        <Col>
          { labels.map(renderLeyends) }
        </Col>
      </Row>

      </Card.Body>
    </Card>
  )
}

export default ComplementoComercioExteriorPropietarioResumen;